import RestoreDocumentType from '@Application/Documents/DocumentTypes/Commands/RestoreDocumentType';
import restoreDocumentType from '@Application/Documents/DocumentTypes/restoreDocumentType';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import useAccountDocumentTypes from '@UI/Hooks/useAccountDocumentTypes';
import { css } from '@emotion/react';
import * as React from 'react';
import { useDispatch } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

const actionsRowStyle = css`
	display: flex;
	align-items: center;
`;

type Props = {
	readonly documentTypeId: number;
};

/**
 * Leaf action: dispatches the restore itself, no callback prop — same pattern as `DocumentTypeActions`.
 * Restoring an archived type is not destructive, so no confirmation guards it, unlike archiving.
 */
const ArchivedDocumentTypeCardActions: React.FC<Props> = ({ documentTypeId }) => {
	const dispatch = useDispatch();
	const { accountId } = useAccountDocumentTypes();

	const handleRestoreClick = React.useCallback(() => {
		// Unreachable in practice: this card only ever renders once the account is resolved — reading
		// the account-scoped catalogue of archived types requires it in the first place.
		if (accountId === null) {
			return;
		}

		dispatch(restoreDocumentType(new RestoreDocumentType(accountId, documentTypeId))).catch(
			ignoreHandledError,
		);
	}, [dispatch, accountId, documentTypeId]);

	return (
		<div css={actionsRowStyle}>
			<Button
				type="button"
				size="sm"
				severity="secondary"
				label="Désarchiver"
				onClick={handleRestoreClick}
			/>
		</div>
	);
};

export default ArchivedDocumentTypeCardActions;
